// import React, { createContext, useContext, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const ChatContext = createContext();

// const ChatProvider = ({ children }) => {
//   const [selectedChat, setSelectedChat] = useState();
//   const [user, setUser] = useState();
//   const [notification, setNotification] = useState([]);
//   const [chats, setChats] = useState();
//    let navigate = useNavigate();

//   const history = useNavigate();

// const getUser = async () => {
//   try {
//     const url = `http://localhost:5000/auth/login/success`;
//     const { data } = await axios.get(url, { withCredentials: true });

//     console.log(data.user.existingUser);
//     localStorage.setItem("userId", data.user.existingUser._id);
//     localStorage.setItem("userINfo", JSON.stringify(data.user.existingUser));
//     const userInfo = JSON.parse(localStorage.getItem("userINfo"));
//      console.log(userInfo)
//     localStorage.setItem("TOKEN", data.user.existingUser.token);
//      navigate("/");
//   } catch (err) {
//     console.log(err);
//   }
// };

//   useEffect(() => {
//     getUser();
//     const userInfo = JSON.parse(localStorage.getItem("userINfo"));
//     setUser(userInfo);
//     console.log("userInfouserInfo", userInfo);

//     // if (!userInfo) history("/");
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [history]);

//   return (
//     <ChatContext.Provider
//       value={{
//         selectedChat,
//         setSelectedChat,
//         user,
//         setUser,
//         notification,
//         setNotification,
//         chats,
//         setChats,
//       }}
//     >
//       {children}
//     </ChatContext.Provider>
//   );
// };

// export const ChatState = () => {
//   return useContext(ChatContext);
// };

// export default ChatProvider;

import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const ChatContext = createContext();

const ChatProvider = ({ children }) => {
  const [selectedChat, setSelectedChat] = useState();
  const [user, setUser] = useState();
  const [notification, setNotification] = useState([]);
  const [chats, setChats] = useState();
  let navigate = useNavigate();

  const history = useNavigate();

  const getUserAndSetUser = async () => {
    try {
      const url = `${process.env.REACT_APP_BASE_URL}/auth/login/success`;
      const { data } = await axios.get(url, { withCredentials: true });

      // console.log(data.user.existingUser);
      localStorage.setItem("userId", data.user.existingUser._id);
      localStorage.setItem("userINfo", JSON.stringify(data.user.existingUser));
      const userInfo = JSON.parse(localStorage.getItem("userINfo"));
      // console.log(userInfo);
      localStorage.setItem("TOKEN", data.user.existingUser.token);
      navigate("/");
      setUser(userInfo);
      // console.log("userInfouserInfo", userInfo);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getUserAndSetUser();
  }, []);

  return (
    <ChatContext.Provider
      value={{
        selectedChat,
        setSelectedChat,
        user,
        setUser,
        notification,
        setNotification,
        chats,
        setChats,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export const ChatState = () => {
  return useContext(ChatContext);
};

export default ChatProvider;
